/**
 * MsalProvider wrapper — hands the singleton PublicClientApplication down
 * to MsalReact's hooks. Rendered above AuthProvider in main.tsx.
 */

import { type ReactNode } from 'react';
import { MsalProvider as ReactMsalProvider } from '@azure/msal-react';

import { msalInstance } from './msal';

export function MsalProvider({ children }: { children: ReactNode }): JSX.Element {
  return <ReactMsalProvider instance={msalInstance}>{children}</ReactMsalProvider>;
}
